import axios from 'axios'
import store from './../store'

const isDev = process.env.NODE_ENV === 'development';
let host;

if (isDev) {
    host = 'http://localhost:8001'
    console.log('host: ' + host)
} else {
    host = process.env.API_HOST || 'https://api.applog.cloud'
}

const axiosInterface = axios.create({
    baseURL: host,
    headers: {
        //Authorization: store.getters.getToken ? `Bearer ` + store.getters.getToken : '',
    }
    /*paramsSerializer: function (params) {
        return Qs.stringify(params, {arrayFormat: 'brackets'})
    },*/
})

axiosInterface.interceptors.request.use(function (config) {
    console.info("request: ", config.url)
    if (config.url && !config.url.includes('api/registration')) {
        let token = store.getters.getToken ? store.getters.getToken : ''
        //console.info("request token: ", token)
        config.headers.Authorization = 'Bearer ' + token
    }
    return config;
})

// Add a response interceptor
axiosInterface.interceptors.response.use(function (response) {
    // Do something with response data
    console.info("response: ", response)
    console.info("status: " + response.status)
    return response;
}, function (error) {
    // Do something with response error
    console.info("ERR: ", error)
    console.info("ERR statusCode: " + error.response.status)
    if (error.response.status === 401) {
        store.commit('unauthorize')
    }
    return Promise.reject(error);
});

export default axiosInterface